module.exports = "/images/code-icon.svg?3f3af35e04eeff7de5d7f80fc084bb8a";